<template>
  <v-container id="contratosTEst-pagina" fluid>
    <v-row justify="center">
      <v-col cols="12" md="11">
        <validation-observer v-slot="{ handleSubmit }">
          <form id="contratoForm" @submit.prevent="handleSubmit(validateForm)">
            <base-material-card color="gold" inline icon="mdi-account-box" :title="tittle" class="px-5 py-3">
              <template v-slot:after-title>
                <v-btn v-if="mode !== 'show' && $can('M_contratos_crear')" :disabled="$disabled()" color="gold" class="mr-0" type="submit" form="contratoForm">
                  Guardar
                </v-btn>
              </template>
              <param-inic ref="parametrosInicContrato" :jugador="dataForm.jugador" :tipo-contrato="dataForm.tipo_contrato" :id-jugador="idJugador" :mode="mode" :in-club="(dataForm.club != undefined) ? dataForm.club : null"
                          :in-sponsor="(dataForm.sponsor != undefined) ? dataForm.sponsor : null" :in-representacion="(dataForm.contrato_padre != null) ? dataForm.contrato_padre : null"
                          :id-contrato-padre="idContratoPadre"
                          @jSelected="dataForm.jugador = $event" @tcSelected="dataForm.tipo_contrato = $event" @sSelected="dataForm.sponsor_id = $event"
                          @cSelected="dataForm.club_id = $event" @crSelected="getDerechosObligacionesPadre"
              />

              <datos-contrato :monto-total="dataForm.total" :descripcion="dataForm.descripcion" :file-id="dataForm.documentacion_id" :mode="mode" :moneda-id="dataForm.moneda_id"
                              @totalChange="dataForm.total = $event" @fileChange="archivoNuevo" @descripcionChange="dataForm.descripcion = $event" @monedaChange="dataForm.moneda_id = $event"
              >
                <template v-slot:fechas>
                  <rango-fechas :in-fecha-desde="dataForm.valido_desde" :in-fecha-hasta="dataForm.valido_hasta" :tipo-contrato="dataForm.tipo_contrato" :jugador="dataForm.jugador" :contrato-padre="dataFormPadre.contrato_padre"
                                :mode="mode" @fDesdeChange="dataForm.valido_desde = $event" @fHastaChange="dataForm.valido_hasta= $event"
                  />
                </template>
              </datos-contrato>
            </base-material-card>
            <derechos-obligaciones v-if="dataForm.tipo_contrato !== null && dataForm.tipo_contrato.permite_derecho_obligacion_sn === 1" ref="doPrincipal" :jugador-club-id="{clubId: dataForm.club_id, jugadorId: dataForm.jugador.id}"
                                   :derecho-representante="dataForm.derecho_representante" :obligacion-representante="dataForm.obligacion_representante" :in-valido-desde="dataForm.valido_desde"
                                   :in-valido-hasta="dataForm.valido_hasta" :club-sn="(dataForm.tipo_contrato.club_sn === 1)" :mode="mode" :condonar="mode === 'edit'"
                                   @borrarDerecho="deleteItemDerecho" @borrarObligacion="deleteItemObligacion" @changeDerechos="dataForm.derecho_representante = $event"
                                   @changeObligaciones="dataForm.obligacion_representante = $event" @cuotasCondonadas="getDerechosObligaciones"
            />

            <derechos-obligaciones v-if="dataForm.tipo_contrato !== null && dataFormPadre.contrato_padre != null" id="prestamo" ref="doPadre" :jugador-club-id="{clubId: dataFormPadre.contrato_padre.club_id, jugadorId: dataFormPadre.contrato_padre.jugador_id}"
                                   :derecho-representante="dataFormPadre.derecho_representante" :obligacion-representante="dataFormPadre.obligacion_representante" :in-valido-desde="dataFormPadre.contrato_padre.valido_desde"
                                   :in-valido-hasta="dataFormPadre.contrato_padre.valido_hasta" :club-sn="(dataForm.tipo_contrato.club_sn === 1)" :mode="modePrestamo" condonar
                                   @borrarDerecho="deleteItemDerecho" @borrarObligacion="deleteItemObligacion" @changeDerechos="cambioDerechoPadre"
                                   @changeObligaciones="dataFormPadre.obligacion_representante = $event" @cuotasCondonadas="getDerechosObligacionesPadre"
            />
          </form>
        </validation-observer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ParamInic from '../../../components/ParametrosInicContrato'
  import DatosContrato from '../../../components/DatosContrato'
  import RangoFechas from '../../../components/RangoValidoFechas'
  import DerechosObligaciones from '../../../components/GenerarDerechosObligaciones'

  export default {
    components: {
      ParamInic,
      DatosContrato,
      RangoFechas,
      DerechosObligaciones,
    },
    props: {
      mode: {
        type: String,
        required: true,
      },
      idContrato: {
        type: Number,
        required: false,
        default: 0,
      },
      idJugador: {
        type: Number,
        required: true,
        default: 0,
      },
      idContratoPadre: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        tittle: '',
        dataForm: {
          idContratoProf: 0,
          contrato_padre: null,
          contrato_padre_id: null,
          club_id: null,
          jugador: null,
          tipo_contrato: null,
          total: 0,
          valido_desde: '',
          valido_hasta: '',
          derecho_representante: [],
          obligacion_representante: [],
          documentacion_id: null,
        },
        dataFormPadre: {
          contrato_padre: null,
          derecho_representante: [],
          obligacion_representante: [],
        },
      }
    },
    computed: {
      modePrestamo () {
        if (this.mode === 'show') {
          return 'prestamos'
        } else {
          return 'prestamo'
        }
      },
    },
    created () {
      this.setTittle()
      if (this.mode === 'show' || this.mode === 'edit') {
        this.getContrato()
      }
      if (this.mode === 'prestamo') {
        this.setearNuevoPrestamo()
      }
    },
    methods: {
      cambioDerechoPadre (event) {
        this.dataFormPadre.derecho_representante = event
      },
      getDerechosObligaciones () {
        if (this.dataForm.id) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/derechos_obligaciones/' + this.dataForm.id }).then(response => {
            this.dataForm.derecho_representante = response[0]
            this.dataForm.obligacion_representante = response[1]
            this.$nextTick(() => {
              this.$refs.doPrincipal.updateDO()
            })
          })
        }
      },
      getDerechosObligacionesPadre (padre = this.dataFormPadre.contrato_padre) {
        this.dataFormPadre.contrato_padre = padre
        this.dataForm.contrato_padre_id = padre.id
        this.$store.dispatch('axiosMod/getData', { url: '/api/derechos_obligaciones/' + padre.id }).then(response => {
          this.dataFormPadre.derecho_representante = response[0]
          this.dataFormPadre.obligacion_representante = response[1]
          this.$nextTick(() => {
            this.$refs.doPadre.updateDO()
          })
        })
      },
      validateForm (scope) {
        this.enviarContrato()
      },
      enviarContrato: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/contrato_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de contrato exitosa'] })
          this.$router.push({ name: 'Listado de Contratos' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = (this.mode === 'new' || this.mode === 'prestamo') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/contrato_agregar',
          data: {
            ...this.dataForm,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de contrato exitosa'] })
          this.$router.push({ name: 'Listado de Contratos' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
          } else if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        }) */
      },
      archivoNuevo (value) {
        this.dataForm.documentacion_id = value
      },
      // Metodos para iniciar la pagina
      setearNuevoPrestamo () {
        this.dataForm.contrato_padre_id = this.idContratoPadre
      },
      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo contrato'
        } else if (this.mode === 'show') {
          this.tittle = 'Informacion contrato'
        } else if (this.mode === 'prestamo') {
          this.tittle = 'Nuevo prestamo'
        } else {
          this.tittle = 'Editar contrato'
        }
      },
      getContrato: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_get/' + this.idContrato })
          .then(response => {
            this.dataForm = response
            this.$nextTick(() => {
              if (this.dataForm.contrato_padre !== null) {
                this.getDerechosObligacionesPadre(this.dataForm.contrato_padre)
              }
            })
          })
      },
      deleteItemDerecho (value) {
        const index = this.dataForm.derecho_representante.indexOf(value)
        if (index > -1) {
          this.dataForm.derecho_representante.splice(index, 1)
        }
      },
      deleteItemObligacion (value) {
        const index = this.dataForm.obligacion_representante.indexOf(value)
        if (index > -1) {
          this.dataForm.obligacion_representante.splice(index, 1)
        }
      },
    },
  }
</script>
